import React, {Component} from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';

import { getFullUser, getAllNotifications } from '../../selectors';
import { notificationActions } from '../../actions';
import './NavBar.css';

class NavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            gotNotifications: false
        };
    }

    toggle = () => {
        this.setState({
          isOpen: !this.state.isOpen
        });
    }

    showNotificationCount() {
        if(this.props.user.newNotificationCount > 0){
            return <span className="notification__badge">{this.props.user.newNotificationCount}</span>;
        }
    }

    showNotifications(){
        let notificationArray = [];
        if(this.props.notifications.length > 0){
            for(let i = 0; i < this.props.notifications.length; i++){
                let dateSent = moment(this.props.notifications[this.props.notifications.length - i - 1].dateSent).format('MMM DD, YYYY hh:mm A');
                notificationArray.push(
                    <li className="notification-card__body-notification" key={`notification-${i}`}>
                        <span href="#" className="notification-media">
                            <span className="notification-media__body">
                                <div className="media-content">{this.props.notifications[this.props.notifications.length - i - 1].message}</div>
                                <div className="media-date">
                                    {dateSent}
                                </div>
                            </span>
                        </span>
                    </li>
                );
            }
        }else{
            notificationArray.push(
                <li className="notification-card__body-notification" key='notification'>
                    <span href="#" className="notification-media">
                        <span className="notification-media__body">
                            <div className="media-content text-center">
                            Nothing to show
                            </div>
                        </span>
                    </span>
                </li>
            );
        }
        return notificationArray;
    }
    renderContent() {
        if(!this.props.user){
            return;
        }

        switch(this.props.user.loggedIn){
            case null:
                return;
            case false:
                return [
                    <NavItem key="schedule" >
                        <NavLink href="/schedule" className="br b--white primary">Schedule</NavLink>
                    </NavItem>,
                    <NavItem key="login" >
                        <NavLink href="/login">Login</NavLink>
                    </NavItem>,
                    <NavItem key="register" >
                        <NavLink href="/register">Register</NavLink>
                    </NavItem>
                ];
            default:
                let menuArray = [
                    <DropdownItem key="setting:1">
                        <Link to="/account/edit" id="AccountEditItem"><i className="fas fa-edit"></i> Edit Account</Link>
                    </DropdownItem>,
                    <DropdownItem key="setting:divider:1" divider />,
                    <DropdownItem key="setting:2">
                        <NavLink href="/api/auth/logout" id="LogoutDDItem"><i className="fas fa-sign-out-alt"></i> Logout</NavLink>
                    </DropdownItem>];

                if(this.props.user.roleId === 2 || this.props.user.roleId === 3){
                    menuArray.unshift(
                        <DropdownItem key="setting:3">
                            <Link to="/admin" id="AdminDDItem"><i className="fas fa-cogs"></i> Admin Panel</Link>
                        </DropdownItem>
                    );
                }

                return [
                    <NavItem key="tokens" >
                        <NavLink disabled href="#" id="NavCredits">Credits: {this.props.user.credits}</NavLink>
                    </NavItem>,
                    <UncontrolledDropdown nav inNavbar key="settings">
                        <DropdownToggle nav caret>
                            {this.props.user.email}
                        </DropdownToggle>
                        <DropdownMenu right>
                            {menuArray}
                        </DropdownMenu>
                    </UncontrolledDropdown>,
                    <UncontrolledDropdown nav inNavbar key="notifications">
                        <DropdownToggle
                            nav
                            onClick={ () => {
                                if(this.state.gotNotifications === false){
                                    this.setState({gotNotifications: true});
                                    this.props.fetchNotifications();
                                }
                            }}>
                            <FontAwesomeIcon icon="bell" />
                            {this.showNotificationCount()}
                        </DropdownToggle>
                        <DropdownMenu right style={{width: '300px', padding: "0px"}}>
                            <div className="notification-card">
                                <header className="notification-card__header">
                                    <span className="heading-font">Notifications</span>
                                </header>
                                <ul className="notification-card__body">
                                    {this.showNotifications()}
                                    {/* <li className="notification-card__body-notification">
                                        <a href="#" className="notification-media">
                                            <span className="">
                                                <img src={profilePicture} className="notification-media__pp" alt="" /> 
                                            </span>
                                            <span className="notification-media__body">
                                                <span className="media-content">Welcome to tbayshinny.com! We are excited to have you and hope to hear from you soon.</span>
                                            </span>
                                        </a>
                                    </li> */}
                                </ul>
                                    {/* <footer class="card-footer text-center">
                                        <a href="javascript:void(0);" class="heading-font text-uppercase f6">See all activity</a>
                                    </footer> */}
                            </div>
                        </DropdownMenu>
                    </UncontrolledDropdown>]
        }
    }

    getBrandRoute(){
        if(!this.props.user || !this.props.user.loggedIn){
            return '/';
        }
        return '/dashboard';
    }

    render(){
        return (
            <Navbar color="dark" dark expand="md">
                <Link to={this.getBrandRoute()} className="logo">TBayShinny</Link>
                <NavbarToggler onClick={this.toggle} />
                <Collapse isOpen={this.state.isOpen} navbar>
                    <Nav className="ml-auto" navbar>
                        {this.renderContent()}
                    </Nav>
                </Collapse>
            </Navbar>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: getFullUser(state),
        notifications: getAllNotifications(state)
    }
}

export default connect(mapStateToProps, notificationActions)(NavBar);


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js